/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteMessageForSelf.defs'
export { main as default } from './deleteMessageForSelf.defs'
